import * as React from 'react'

function SvgTireSummerIcon(props) {
  return (
    <svg
      width={48}
      height={48}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M20.387 32.931a14.153 14.153 0 0 0 1.687-.271c.11-.985.338-1.934.671-2.832-.612.211-1.25.372-1.908.479l-.443-.596a1.371 1.371 0 0 0-1.144-.532c-.6.016-1.192-.022-1.769-.109-.294-.044-.515.298-.337.537l.579.779c-.966-.108-1.9-.337-2.785-.673l-.086-.739a1.373 1.373 0 0 0-.724-1.032 10.237 10.237 0 0 1-1.48-.984c-.232-.186-.594 0-.56.296l.113.964a11.515 11.515 0 0 1-2.075-1.973l.294-.68c.176-.409.12-.877-.112-1.257-.306-.501-.57-1.032-.788-1.587-.11-.278-.516-.298-.634-.025l-.385.892a11.412 11.412 0 0 1-.808-2.75l.596-.444c.357-.265.543-.698.532-1.143-.016-.601.022-1.192.109-1.77.044-.294-.298-.515-.537-.337l-.778.58c.107-.967.336-1.901.672-2.786l.739-.086c.441-.052.819-.333 1.032-.723.285-.522.614-1.017.984-1.48.185-.233 0-.595-.296-.56l-.965.112c.568-.77 1.231-1.467 1.974-2.075l.68.294c.409.176.877.12 1.257-.112.501-.306 1.031-.57 1.587-.788.277-.109.298-.516.025-.634l-.892-.385a11.413 11.413 0 0 1 2.751-.808l.443.596c.266.357.7.543 1.144.532.6-.016 1.192.022 1.77.109.293.044.514-.298.337-.537l-.58-.778c.966.107 1.9.336 2.785.672l.087.739c.051.442.332.82.723 1.032.521.285 1.017.615 1.48.984.232.186.594 0 .56-.295l-.113-.965c.77.568 1.468 1.23 2.075 1.973l-.293.68c-.177.41-.122.878.111 1.258.306.5.571 1.031.789 1.587.108.277.515.298.633.024l.385-.891c.377.863.652 1.784.808 2.75l-.596.444a1.37 1.37 0 0 0-.532 1.144c.016.6-.022 1.191-.109 1.769-.044.294.298.515.537.337l.779-.579a11.373 11.373 0 0 1-.558 2.467 11.923 11.923 0 0 1 2.834-.671c.32-1.426.422-2.927.27-4.46-.767-7.695-7.625-13.311-15.319-12.545-7.694.766-13.31 7.624-12.544 15.318s7.624 13.31 15.318 12.544Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.756 26.599A7.636 7.636 0 1 0 18.243 11.4 7.636 7.636 0 0 0 19.757 26.6Zm-.252-2.533a5.09 5.09 0 1 0-1.008-10.132 5.09 5.09 0 0 0 1.008 10.132Z"
        fill="#000"
      />
      <path
        d="M35 25a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2ZM35 41a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2ZM40 34a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1ZM25 33a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 34a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5 3a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
        fill="#000"
      />
      <path
        d="M26.929 26.929a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1-1.414 1.414l-1.414-1.414a1 1 0 0 1 0-1.414ZM39.657 38.243a1 1 0 0 0-1.414 1.414l1.414 1.414a1 1 0 0 0 1.414-1.414l-1.414-1.414ZM38.243 29.757a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 1.414l-1.414 1.414a1 1 0 0 1-1.414 0ZM26.929 39.657a1 1 0 0 0 1.414 1.414l1.414-1.414a1 1 0 0 0-1.414-1.414l-1.414 1.414Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgTireSummerIcon
